/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
// tab page
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";
import PartnerSiteInfo from "../../../components/Partner/PartnersiteInfo";
import PartnerInfo from "../../../components/Partner/PartnerInfo";


import queryString from "query-string";

const Pertner = (props) => {
  const history = useHistory();
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
    shallowEqual
  );

  const [targetPermission, setTargetPermission] = useState(null);

  const [activeTab, setActiveTab] = useState(0);

  const _setActiveTab = (value) => {
    history.push({
      search: `?tab=${value}`
    });
    setActiveTab(value);
  };

  const tabList = [
    {
      label: "파트너스 정보",
      action: _setActiveTab,
      value: "partnerInfo",
    },
    {
      label: "홈페이지 정보",
      action: _setActiveTab,
      value: "partnerSiteInfo",
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(
        (p) => p.code === "COMPANY_MANAGEMENT"
      );
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "COMPANY_MANAGEMENT");
      }
    }
  }, [permissions]);


  return (
    !isEmpty(targetPermission) && (
      <div className="page-content">
        <PageHeader title={"내 정보"}
          activeTab={activeTab}
          tabList={tabList} />
        {activeTab === 'partnerInfo' &&
          <PartnerInfo
            mode={"create"}
          />}
        {activeTab === 'partnerSiteInfo' &&
          <PartnerSiteInfo
            mode={"create"}
          />}
      </div>
    )
  );
};

export default Pertner;
